import React, { useState } from 'react';  
import { useNavigate } from 'react-router-dom';  
import { CreateQuestionnaireTemplateByTitle, CreateImproveTemplateByTitle, CreateDevelopTemplateByTitle } from '../../../API/TemplateBank/TemplateBank';  
import TemplateManagement from '../../../Components/Utils/TemplateManagement/TemplateManagement';
import { ITab } from '../../../Types/ITab';
import {useAppSelector} from "../../../Redux/Store/Store";
import {getClient} from "../../../Redux/Store/Slices/client";
import { IDropDownListItem } from '../../../Types/DropDownList/IDropDownListItem';
import DropDownList from '../../../Components/Utils/DropDownList/DropDownList';
import { toast } from 'react-toastify';
import styles from './TemplateBankItems.module.css';
import { ProductType } from '../../../Types/ProductType';

const tabs: ITab[] = [
  {
    title: "Active",
    active: true,
    url: "/template-editor/active"
  },
  {
    title: "Archive",
    active: false,
    url: "/template-editor/archive"
  }
]

const templateTypeOptions: IDropDownListItem[] = [
  { value: 'Evaluate', text: 'Evaluate', colour: '#24394F', textColour: '#FFFFFF' },
  { value: 'Improve', text: 'Track', colour: '#52BFA2', textColour: '#FFFFFF' },
  { value: 'Develop', text: 'Develop', colour: '#24394F', textColour: '#FFFFFF' }
];
  
const TemplateBankItems = () => {  
  const navigate = useNavigate();
  const client = useAppSelector(getClient);
  const [templateType, setTemplateType] = useState<IDropDownListItem | null>(null);
  
  const createTemplate = async (title: string, templateType: string) => {
    if (!templateType) {
      toast.warning('Please select a template type before creating.');
      return;
    }
    
    if(client){
      try {
        let templateId: string;
        const encodedTitle = encodeURIComponent(title);
        
        if (templateType === 'Improve') {
          templateId = await CreateImproveTemplateByTitle(title, client.id);
          navigate(`/template-editor/improve/${templateId}/${encodedTitle}/improve-template-creation`);
        } else if (templateType === 'Develop') {
          templateId = await CreateQuestionnaireTemplateByTitle(title, client.id, ProductType.Develop);
          navigate(`/template-editor/develop/${templateId}/${encodedTitle}/define-fields`);
        } else {
          templateId = await CreateQuestionnaireTemplateByTitle(title, client.id, ProductType.Evaluate);
          navigate(`/template-editor/evaluate/${templateId}/${encodedTitle}/define-fields`);
        }
      } catch (error) {
        console.error('Error creating template:', error);
        toast.error('Failed to create template. Please try again.');
      }
    }
  };  

  return (  
    <div>
      <TemplateManagement 
        tabs={tabs}
        showCreateButton={true}
        onCreateTemplate={createTemplate}
        createButtonPlaceholder={'Enter title for new template'}
        createButtonNoTextMessage={'The Title field is required'}
        showTitleEdit={true}
        mesmaOnly={true}
      />
    </div>
  );  
};  
  
export default TemplateBankItems;  